'use client';

import { PROFILE_BANNER_DESKTOP_HEIGHT_RATIO } from '@/features/profile/constants/image-crop';

/**
 * VK model overlays: outer frame = mobile; clear center band = desktop;
 * gray top+bottom = mobile-only parts of the frame.
 */
export function BannerDeviceGuides(): React.JSX.Element {
  const mobileOnlyBandPercent = ((1 - PROFILE_BANNER_DESKTOP_HEIGHT_RATIO) / 2) * 100;
  const desktopBandPercent = PROFILE_BANNER_DESKTOP_HEIGHT_RATIO * 100;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="absolute inset-x-0 top-0 border-b border-dashed border-white"
        style={{
          height: `${mobileOnlyBandPercent}%`,
          backgroundColor: 'rgba(120, 120, 120, 0.55)',
        }}
      >
        <span
          className="absolute left-1/2 top-2 max-w-[92%] -translate-x-1/2 rounded-md px-2.5 py-1 text-center text-[11px] leading-tight text-white"
          style={{ backgroundColor: 'rgba(45, 45, 45, 0.85)' }}
        >
          Эта область видна на мобильных устройствах
        </span>
      </div>
      <div
        className="absolute inset-x-0 border-y border-dashed border-white/90"
        style={{
          top: `${mobileOnlyBandPercent}%`,
          height: `${desktopBandPercent}%`,
        }}
      >
        <span
          className="absolute bottom-2 left-2 rounded-md px-2.5 py-1 text-[11px] leading-tight text-white"
          style={{ backgroundColor: 'rgba(45, 45, 45, 0.85)' }}
        >
          Эта область видна на компьютерах
        </span>
      </div>
      <div
        className="absolute inset-x-0 bottom-0 border-t border-dashed border-white"
        style={{
          height: `${mobileOnlyBandPercent}%`,
          backgroundColor: 'rgba(120, 120, 120, 0.55)',
        }}
      />
    </div>
  );
}
